import { gql } from '@apollo/client';

/* ── behavioural risk, per security ─────────────────────────── */

export const BEHAVIORAL_RISK = gql`
  query BehavioralRisk($securitySymbol: String!, $userHorizon: String!, $userRisk: String!) {
    getBehavioralRisk(securitySymbol: $securitySymbol, userHorizon: $userHorizon, userRisk: $userRisk) {
      securitySymbol
      date
      userRisk
      userHorizon
      summary { highRiskCount improvingCount worseningCount inDrawdownCount }
      biases {
        id
        name
        subtitle
        isPositiveTrait
        score
        level
        verdict
        advice
        insight
      }
    }
  }
`;
